import { useEffect } from "react";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";

const ScrollToTop = (props) => {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <div>{props.children}</div>;
};

export default ScrollToTop;
